import React, { useState } from 'react';
import { FiAlertTriangle } from 'react-icons/fi';

const InstructionsModal = ({ isOpen, onClose }) => {
    const [isInstructionsChecked, setIsInstructionsChecked] = useState(false);
    const [isTermsChecked, setIsTermsChecked] = useState(false);

    const isProceedEnabled = isInstructionsChecked && isTermsChecked;

    return (
        <div className={`fixed inset-0 bg-slate-900 bg-opacity-60 flex justify-center items-center z-50 p-4 transition-all duration-300 ease-in-out ${isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}>
            <div className={`bg-white rounded-xl shadow-2xl max-w-4xl w-full transition-all duration-300 ease-in-out ${isOpen ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`}>
                <div className="p-8 border-b">
                    <h2 className="text-2xl font-bold text-slate-800">Election Form Instructions & Agreement</h2>
                </div>
                <div className="p-8 max-h-[60vh] overflow-y-auto text-slate-600">
                    <h3 className="text-xl font-semibold text-slate-800 mb-4">Instructions</h3>
                    <p className="mb-4">Please fill out the election form carefully. Make sure to double-check all the information before submitting.</p>
                    <ul className="list-disc list-inside space-y-2 mb-6">
                        <li>Fields marked with an asterisk (*) are mandatory.</li>
                        <li>Ensure that you have all the necessary documents ready for upload.</li>
                        <li>Review the form thoroughly before submission to avoid any errors.</li>
                    </ul>
                    
                    <div className="rounded-lg bg-yellow-50 border border-yellow-200 p-4 mt-6">
                        <h4 className="font-bold text-yellow-800 flex items-center"><FiAlertTriangle className="inline-block mr-2" />IMPORTANT</h4>
                        <p className="text-yellow-700 mt-2">Reloading the page or navigating away will discard all entered data. Proceed with caution.</p>
                    </div>

                    <h3 className="text-xl font-semibold text-slate-800 mt-8 mb-4">Agreement for CDONHS-JH SSLG Election Return Portal</h3>
                    <p>By accessing and using this portal, you acknowledge and agree to the following terms:</p>
                    <ol className="list-decimal list-inside space-y-3 mt-4">
                        <li><strong>Confidentiality:</strong> You will not share, distribute, or disclose any information contained in this portal, including election results, voter details, or any related data.</li>
                        <li><strong>Restricted Access:</strong> You will not share the portal link, credentials, or any means of access with unauthorized individuals.</li>
                        <li><strong>Compliance with Data Privacy Act of 2012:</strong> You commit to protecting voter information and ensuring compliance with the Republic Act No. 10173. Unauthorized collection, processing, or dissemination of election-related data is strictly prohibited.</li>
                        <li><strong>Accountability:</strong> Any misuse, unauthorized access, or breach of these terms may result in restrictions from accessing this portal and possible legal consequences.</li>
                    </ol>
                </div>
                <div className="p-8 bg-slate-50 rounded-b-xl border-t">
                    <div className="space-y-4">
                        <label className="flex items-center cursor-pointer">
                            <input
                                type="checkbox"
                                className="h-5 w-5 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                                checked={isInstructionsChecked}
                                onChange={() => setIsInstructionsChecked(!isInstructionsChecked)}
                            />
                            <span className="ml-3 text-slate-700">I have read and understood the instructions.</span>
                        </label>
                        <label className="flex items-center cursor-pointer">
                            <input
                                type="checkbox"
                                className="h-5 w-5 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                                checked={isTermsChecked}
                                onChange={() => setIsTermsChecked(!isTermsChecked)}
                            />
                            <span className="ml-3 text-slate-700">I agree to the terms and conditions.</span>
                        </label>
                    </div>
                    <button
                        className={`w-full mt-6 font-bold py-3 px-4 rounded-lg transition-colors ${!isProceedEnabled ? 'bg-slate-300 text-slate-500 cursor-not-allowed' : 'bg-blue-500 hover:bg-blue-600 text-white'}`}
                        onClick={onClose}
                        disabled={!isProceedEnabled}
                    >
                        Proceed to Form
                    </button>
                </div>
            </div>
        </div>
    );
};

export default InstructionsModal;